module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Laptop-macbook-94f21bf37dffa90a95b52bc173ab14f7.svg";